module.exports = __webpack_public_path__ + "media/images/medium-loader-e056740a.gif";